import React from "react";
import {
  CircleProps,
  ProgressCircleProps,
  TextProps,
  RangeColor,
} from "./ProgressCircle.types";
import { AllieColors } from "../../common/color.types";
import { StyledCircle } from "./ProgressCircle.styles";
import { breakpointsDefault } from "../CircularProgressBar";

const cleanPercentage = (percentage: number): number => {
  const tooLow = !Number.isFinite(+percentage) || percentage < 0;
  // const tooHigh = percentage > 100;
  return tooLow ? 0 : +percentage;
};

const getColorFromRanges = (
  ranges: RangeColor[] = breakpointsDefault,
  pct: number
): string => {
  for (const range of ranges) {
    if (pct >= range.start && pct <= range.end) {
      return range.color;
    }
  }
  return "";
};

const selectColor = (
  backgroundColor: AllieColors | undefined,
  breakpoints: RangeColor[] = breakpointsDefault,
  strokePct: number
): string => {
  return backgroundColor
    ? `var(--allie-color-${backgroundColor})`
    : `var(--allie-color-${getColorFromRanges(breakpoints, strokePct)})`;
};

const Circle: React.FC<CircleProps> = ({
  pct,
  breakpoints,
  backgroundColor,
  cx,
  cy,
  radius = 70,
  strokeWidth = "0.313rem",
}) => {
  const circ = 2 * Math.PI * radius;
  const strokePct = ((100 - pct) * circ) / 100;
  return (
    <StyledCircle
      r={radius}
      cx={cx}
      cy={cy}
      fill="transparent"
      stroke={
        strokePct !== circ
          ? selectColor(backgroundColor, breakpoints, pct)
          : `var(--allie-color-${getColorFromRanges(breakpoints, strokePct)})`
      }
      strokeWidth={strokeWidth}
      strokeDasharray={circ}
      strokeDashoffset={pct ? strokePct : 0}
      strokeLinecap="round"
    ></StyledCircle>
  );
};

const Text: React.FC<TextProps> = ({ percentage, textStyle }) => {
  return (
    <text
      x="50%"
      y="50%"
      dominantBaseline="central"
      textAnchor="middle"
      // fontSize={"1.5em"}
      className={`allie-text-${textStyle}`}
    >
      {percentage > 999 ? '+999' : percentage}%
    </text>
  );
};

export const AllieProgressCircle: React.FC<ProgressCircleProps> = ({
  percentage = 0,
  text = "h4",
  breakpoints = breakpointsDefault,
  backgroundColor = "light-80",
  width = 200,
  height = 200,
  cx = 100,
  cy = 100,
  radius = 70,
  strokeWidth = "0.313rem",
}) => {
  const pct = cleanPercentage(percentage);
  return (
    <>
      <svg width={width} height={height}>
        <g transform={`rotate(-90 ${"100 100"})`}>
          <Circle
            cx={cx}
            cy={cy}
            radius={radius}
            backgroundColor={backgroundColor}
            pct={100}
            strokeWidth={strokeWidth}
            breakpoints={breakpoints}
          />
          <Circle
            cx={cx}
            cy={cy}
            radius={radius}
            pct={pct > 100 ? 100 : pct}
            strokeWidth={strokeWidth}
            breakpoints={breakpoints}
          />
        </g>
        <Text percentage={pct} textStyle={text} />
      </svg>
    </>
  );
};
